<div class="card-container mb-3">
    <div class="title mb-2">
        Review SASS
    </div>
    <div class="content">
        This page is to test all styles in the system.
    </div>
</div>
<div>
    <mat-tab-group>
        <mat-tab>
            <ng-template mat-tab-label>
                Form
            </ng-template>
            <div class="pt-3">
                <div>
                    <mwp-agent-sass-mat-form/>
                </div>
                <div class="message-card my-3">
                    <div class="fw-bold">
                        Custom Form Controls
                    </div>
                    <div>
                        Due to rendering calcultions we do for the signature pad, this need to be the first page or initial render will not align correctly.
                    </div>
                    <div>
                        Typically this lifes on a signle page and loaded in view of the user, not hidden.
                    </div>
                    <div>
                        When the windows is resized the pad clears as auto image resizing causes artifacting
                    </div>
                </div>
                <div>
                    <mwp-agent-sass-custom-controls/>
                </div>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Controls
            </ng-template>
            <div class="pt-3">
                <mwp-agent-sass-mat-controls/>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Tables
            </ng-template>
            <div class="pt-3">
                <mwp-agent-sass-tables/>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Menus
            </ng-template>
            <div class="pt-3">
                <mwp-agent-sass-menu />
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Buttons
            </ng-template>
            <div class="pt-3">
                <div class="mb-3">
                    <mwp-agent-sass-buttons/>
                </div>
                <mwp-agent-sass-toast />
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                Containers
            </ng-template>
            <div class="pt-3">
                <mwp-agent-sass-containers />
            </div>
        </mat-tab>
        
        
    </mat-tab-group>
</div>
